<div class="path-activity-selector">
	<div class="activities-container">
		@for (activity of activities(); track activity; let i = $index) {
			@if (activity) {
				<app-carousel-activity
					[ngClass]="['fade-in-with-wait-' + i]"
					[activity]="activity"
					(click)="selectActivity(activity)"
					[style.zIndex]="activities().length - i"
					[completed]="isActivityCompleted(activity)"
					[started]="isActivityStarted(activity)"
				>
					{{ i + 1 }}.
				</app-carousel-activity>
			}
		}
	</div>

	<svg #svgPath id="largeScreenPath" class="pathSVG" viewBox="0 0 500 1760" preserveAspectRatio="xMidYMid meet">
		<path
			#path
			class="path"
			style="fill: none; stroke-miterlimit: 10"
			d="M0 61c107-9 130 32 298 1 133-24 169 24 145 84-25 64-160 61-256 29C71 135 24 250 80 305c60 59 178 13 258-2 112-22 156 111 72 166-83 55-173 21-235-3-151-60-161 164-14 188 111 19 144-58 221-36 86 26 91 154-17 179-103 24-150-7-195-15-44-9-111 33-97 114 12 64 86 140 181 51 81-76 175-28 176 73 2 210-408-39-365 185 18 98 203 65 282 50s102 47 83 111c-22 77-273 15-312 17s-72 50-45 102 58 59 177 39c113-19 177-19 186 42 12 84-36 111-150 103s-143-26-179 1c-41 30-34 84-34 104"
		/>
	</svg>

	<svg #svgPath id="mediumScreenPath" class="pathSVG" viewBox="0 0 500 3000" preserveAspectRatio="xMidYMid meet">
		<path
			#path
			class="path"
			d="M87 0c0 168 110 145 199 111 105-41 156 27 141 131-16 111-139 87-231 58-148-47-181 173-87 205 75 26 151-14 220-23 113-14 135 87 83 168-44 70-129 41-216 32-169-17-182 177-68 229 107 49 135-12 209-14 117-2 102 145 67 206-45 81-152 26-189 19-103-18-136 83-124 217 10 106 83 152 145 84 62-67 215-70 178 92-49 218-243-3-309 242-21 80-53 204 35 220 180 34 41-191 186-180 113 9 109 132 71 286-33 135-186 57-247 57-72 0-83 71-62 156 22 89 244-27 297 61 94 155-270 76-293 256-23 179 173 52 173 387"
			style="fill: none; stroke-miterlimit: 10"
		/>
	</svg>

	<svg #svgPath id="smallScreenPath" class="pathSVG" viewBox="0 0 500 13790" preserveAspectRatio="xMidYMid meet">
		<path
			#path
			class="path"
			d="M166 0c0 229 164 223 164 422S166 613 166 861c0 229 164 224 164 423s-164 190-164 439c0 229 164 223 164 422s-164 190-164 439c0 229 164 223 164 423s-164 190-164 439c0 228 164 223 164 422s-164 190-164 439c0 229 164 223 164 422s-164 191-164 439c0 229 164 224 164 423s-164 190-164 439c0 229 164 223 164 422s-164 190-164 439c0 229 164 223 164 423s-164 190-164 439c0 228 164 223 164 422s-164 190-164 439c0 229 164 223 164 422s-164 191-164 440c0 228 164 223 164 422s-164 190-164 439c0 229 164 223 164 422s-164 190-164 439c0 229 164 224 164 423s-164 190-164 439c0 229 164 223 164 422s-164 190-164 439c0 229 164 223 164 422s-164 191-164 440"
			style="fill: none; stroke-miterlimit: 10"
		/>
	</svg>

	<!--svg #svgPath class="pathSVG" viewBox="0 0 420 1850" preserveAspectRatio="xMidYMid meet">
  <path
    #path
    class="path"
    d="M86.5 0c0 290.15 277.95-51.95 257.58 279.15-11.82 192-250.22-22.23-251.35 194.26-1.18 225.88 248.46 20.25 256.72 201.03 10.74 234.92-258.63 5.88-249.2 252.99 7.41 194.26 239.21-2.88 256.72 146.82 33.3 284.61-236.25 30.49-238.46 228.14-2.15 192 223.78-33.99 226.65 246.21 2.88 281.62-258.65 1.43-258.65 327.53"
    />
</svg-->
</div>
